export enum Themes {
  Light = 'Light',
  Dark = 'Dark',
}
export const themeList: string[] = [Themes.Light, Themes.Dark] as const
